<template>
  <div>
    <el-table
      class="banner-table"
      :data="bannerList"
      height="calc(100vh - 200px)"
      :row-key="() => Math.random()"
      :fit="true"
    >
      <el-table-column prop="__platform" label="平台"> </el-table-column>
      <!-- <el-table-column prop="tenantId" label="商户id"> </el-table-column> -->
      <!-- <el-table-column
        prop="__positionType"
        label="广告位置">
      </el-table-column> -->
      <el-table-column prop="__language" label="语言类型"> </el-table-column>
      <el-table-column prop="subjectType" label="主题">
        <template slot-scope="scope">
          <span v-if="scope.row.subjectType == 'black'">黑夜</span>
          <span v-else>白天</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" width="120">
        <template slot-scope="scope">
          {{
            (
              bannerTypes.find(
                (item) => Number(item.type) === scope.row.type
              ) || {}
            ).message
          }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题"> </el-table-column>
      <el-table-column label="图片" label-width="120" width="140">
        <template slot-scope="scope">
          <!-- {{scope.row.imageUrl}} -->
          <image-wrapper :src="scope.row.imageUrl" class="img"></image-wrapper>
        </template>
      </el-table-column>
      <el-table-column label="跳转地址" width="200">
        <template slot-scope="scope">
          <a :href="scope.row.linkUrl" target="_blank">
            {{ scope.row.jumpOption === 1 ? scope.row.linkUrl : '--' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="跳转页面" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.jumpOption === 2">
            {{ code[scope.row.page] }}
            {{ scope.row.params ? `(${scope.row.params})` : '' }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleUpdate(scope.row.id)"
          ></el-button>
          <el-button
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleRemove(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <banner-detail :value="bannerId" @refresh="refreshList"></banner-detail>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import ImageWrapper from 'components/image'
import BannerDetail from '../detail'
import SortableMixin from 'mixins/SortableMixin'
import { CODE } from '../../constants'

export default {
  name: 'BannerList',
  mixins: [SortableMixin],
  data() {
    return {
      bannerId: null,
      sortable: '.banner-table',
      baseDomain: '',
      code: CODE,
    }
  },
  components: {
    ImageWrapper,
    BannerDetail,
  },
  computed: {
    ...mapState('settingBanner', ['bannerTypes']),
    ...mapGetters('settingBanner', ['bannerList']),
  },
  methods: {
    ...mapMutations('settingBanner', ['toggleDetailDialogVisible']),
    ...mapActions('settingBanner', ['list', 'remove', 'updateSort']),
    handleUpdate(id) {
      this.bannerId = id
      this.toggleDetailDialogVisible(true)
    },
    handleRemove(id) {
      this.$confirm('确认删除此广告吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.remove(id).then(() => {
            this.$message.success('删除成功！')
            this.$emit('refresh')
          })
        })
        .catch(() => {})
    },
    onSort(evt) {
      const { oldIndex, newIndex } = evt

      if (oldIndex !== newIndex) {
        const banner = this.bannerList[oldIndex]

        this.updateSort({
          id: banner.id,
          language: banner.language,
          platform: banner.platform,
          type: banner.type,
          orderNo: newIndex + 1,
        }).then(() => {
          this.$message.success('更新成功！')
          this.$emit('refresh')
        })
      }
    },
    refreshList() {
      this.$emit('refresh')
    },
    getDomain() {
      const { protocol } = window.location

      const res = document.domain
      console.log('domain-res', res)
      console.log('protocol', protocol)
      this.baseDomain = protocol + '//' + res
    },
  },
  mounted() {
    this.getDomain()
    console.log('domain-base', this.baseDomain)
  },
}
</script>

<style lang="less" scoped>
.image-container {
  padding: 7px;
}
// .img{
//   background-size: 100%;
// }
</style>
